angular.module('acme.view.application.orders.offline.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.detailList',
  'acme.common.directive.dataGrid',
  'acme.view.application.orders.offline.list.controllers',
  'acme.view.application.orders.offline.order.detail.controllers',
  'acme.view.application.orders.offline.detail.controllers'
]).config(function config($stateProvider) {
  var offline = {
    name: 'application.orders.offline.list',
    url: '/list',
    views: {
      "subview-main": {
        controller: 'OfflineListController',
        controllerAs: '$ctrl',
        templateUrl: 'views/application/views/orders/offline/list/list.tpl.html'
      }
    },
    data: {
      pageTitle: 'Offline Transactions',
      permissions: [
        'OFFLINE_TRANSACTIONS_VIEW'
      ],
      enablePreferences: true
    }
  };

  $stateProvider
    .state(offline);
});
